import { render, staticRenderFns } from "./RoleSetUsers.vue?vue&type=template&id=42202cc1&"
import script from "./RoleSetUsers.vue?vue&type=script&lang=js&"
export * from "./RoleSetUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports